import { useEffect } from 'react';
import SkeletonCard from '../cards/SkeletonCard';
import InsightCard from '../cards/InsightCard';
import EventWebinarCard from '../cards/EventWebinarCard/EventWebinarCard';
import GenericCard from '../cards/GenericCard';
import { device } from '../../../utils/styled-component-mixins';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import SearchListView from './SearchListView';

const SkeletonCards = () => Array.from(Array(12), (_, i) => <SkeletonCard key={i} />);

const SearchResults = ({
  isLoading,
  results,
  insightReadMoreText,
  eventRegisterText,
  isGridView
}) => {
  const isDesktop = useMediaQuery(device.desktop);

  useEffect(() => {
    // iOS mobile and tablet fix
    const vh = window.innerHeight * 0.01;
    document.querySelector('#search-filters').style.height = `calc(${vh}px * 100)`;

    window.addEventListener('resize', () => {
      const vhUpdated = window.innerHeight * 0.01;
      document.querySelector('#search-filters').style.height = `calc(${vhUpdated}px * 100)`;
    });
  }, []);

  return (
    <>
      {isGridView || !isDesktop ? (
        <div className="card-grid" id="search-results">
          {isLoading ? (
            <SkeletonCards />
          ) : (
            results.map((result) => {
              if (result.classname === 'bdo.insightnode') {
                return (
                  <InsightCard
                    isSearchResultCard={true}
                    item={{
                      thumbnail1: result.thumbnailimage,
                      primaryCategory: result.primarycategory,
                      pageTitle: result.pagetitle,
                      description: result.description,
                      url: result.url,
                      readMoreText: insightReadMoreText,
                      publishDate: result.sys_created
                    }}
                    cardProps={{
                      layout: 'standard'
                    }}
                    key={result.nodeguid}
                  />
                );
              }
              if (result.classname === 'bdo.eventwebinarnode') {
                return (
                  <EventWebinarCard
                    key={result.nodeguid}
                    city={result.city}
                    state={result.eventState}
                    dateFrom={result.startdatetime}
                    description={result.description}
                    pageTitle={result.pagetitle}
                    eventType={result.eventtype}
                    slug={result.url}
                    cardCtaText={eventRegisterText}
                    timeZone={result.timezone}
                    isSearchResultsEventCard={true}
                    cardIsExternal={result.cardisexternal}
                    cardExternalLink={result.cardexternallink}
                    disclaimer={result.disclaimer}
                  />
                );
              }

              return (
                <GenericCard
                  key={result.nodeguid}
                  item={{
                    pageTitle: result.pagetitle,
                    description: result.description,
                    url: result.url,
                    readMoreText: insightReadMoreText
                  }}
                />
              );
            })
          )}
        </div>
      ) : (
        <SearchListView
          isLoading={isLoading}
          results={results}
          insightReadMoreText={insightReadMoreText}
        />
      )}
    </>
  );
};

export default SearchResults;
